import { Component } from '@angular/core';
import { iBisBaseComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { EditServicePackageService } from './edit-service-package.service';

@Component({
    selector: 'app-edit-service-package',
    templateUrl: './edit-service-package.component.html'
})
export class EditServicePackageComponent extends iBisBaseComponent {
    public declare edit: EditServicePackageService;
    constructor(public proxy: ProxyService) {
        super(proxy.servicePackage, proxy.lg, proxy.iui, proxy.activatedRoute);
    }
}
